'use strict';

const getQueryValues = () => {
	if ( ! window.location.search ) {
		return null;
	}

	return window.location.search
		.replace( '?', '' )
		.trim()
		.split( '&' )
		.reduce( ( acc, val ) => {
			const keyval = val.split( '=' );
			const obj = {};
			obj[ keyval[ 0 ] ] = keyval[ 1 ];
			return { ...acc, ...obj };
		}, {} );
};

const navToggle = $ => {
	const $menu = $( '#site-navigation' );

	const toggle = $btn => {
		if ( $( 'body' ).hasClass( 'menu-opening' ) || $( 'body' ).hasClass( 'menu-closing' ) ) {
			return;
		}

		const status = $btn.attr( 'aria-expanded' ) === 'false' ? 'closed' : 'open';

		if ( status === 'closed' ) {
			openNav();
		} else {
			closeNav();
		}
	};

	const openNav = () => {
		$( 'body' ).removeClass( 'menu-closed' )
			.addClass( 'menu-opening' );

		$menu.css( { display: 'block' } )
			.animate( {
				width: '100%',
				height: '100%'
			}, 300, function() {
				$( 'body' ).removeClass( 'menu-opening' )
					.addClass( 'menu-open' );
				$( '.navbar-toggle' ).attr( 'aria-expanded', 'true' );
				preventScroll();
			} );
	};

	const closeNav = () => {
		$( 'body' ).removeClass( 'menu-open' )
			.addClass( 'menu-closing' );

		$menu.animate( {
			width: 0,
			height: 0
		}, 200, function() {
			$( 'body' ).removeClass( 'menu-closing' )
				.addClass( 'menu-closed' );
			$( '.navbar-toggle' ).attr( 'aria-expanded', 'false' );
			$menu.css( { display: 'none' } );
			resumeScroll();
		} );
	};

	const preventScroll = () => {
		const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

		$( 'html' ).css( { overflow: 'hidden' } );

		if ( scrollBarWidth > 0 ) {
			const paddingRight = scrollBarWidth + 'px';
			$( 'body' ).css( { 'padding-right': paddingRight } );
		}
	};

	const resumeScroll = function() {
		$( 'body' ).css( { 'padding-right': 0 } );
		$( 'html' ).css( { overflow: 'auto' } );
	};

	return {
		bind() {
			$( '.navbar-toggle' ).on( 'click', e => {
				toggle( $( e.currentTarget ) );
			} );
		}
	};
};

navToggle( jQuery ).bind();

const searchToggle = ( $ ) => {
	const $form = $( '#nav-searchform' );

	const toggle = $btn => {
		const status = $btn.attr( 'aria-expanded' ) === 'false' ? 'closed' : 'open';

		if ( status === 'closed' ) {
			showSearch();
		} else {
			hideSearch();
		}
	};

	const showSearch = () => {
		const newWidth = $form.get( 0 ).scrollWidth;

		$form.animate( {
			width: newWidth
		}, 400, () => {
			$( '.search-toggle' ).attr( 'aria-expanded', 'true' );
		} );
	};

	const hideSearch = () => {
		$form.animate( {
			width: 0
		}, 400, () => {
			$( '.search-toggle' ).attr( 'aria-expanded', 'false' );
		} );
	};

	return {
		bind() {
			$( '.search-toggle' ).on( 'click', e => {
				toggle( $( e.currentTarget ) );
			} );
		}
	};
};

searchToggle( jQuery ).bind();

const tabToggle = function( $ ) {
	const toggle = function( action ) {
		const { button, panel } = action;
		const $button = $( '#' + button );

		if ( $button.attr( 'aria-selected' ) === 'true' ) {
			return;
		}

		$( 'select.tab-select' ).val( button );

		const $group = $( '#' + button ).parents( '[data-tab="group"]' );
		const $activeButton = $group.find( '[role="tab"][aria-selected="true"]' );
		const $activePanel = $group.find( '[role="tabpanel"][aria-hidden="false"]' );

		toggleButton( button );
		toggleButton( $activeButton.attr( 'id' ) );
		togglePanel( panel );
		togglePanel( $activePanel.attr( 'id' ) );
	};

	const toggleButton = function( buttonId ) {
		const $button = $( '#' + buttonId );

		if ( $button.attr( 'aria-selected' ) === 'false' ) {
			$button.attr( 'aria-selected', 'true' );
		} else {
			$button.attr( 'aria-selected', 'false' );
		}
	};

	const togglePanel = function( panelId ) {
		const $panel = $( '#' + panelId );

		if ( $panel.attr( 'aria-hidden' ) === 'false' ) {
			$panel.fadeOut().attr( 'aria-hidden', 'true' );
		} else {
			$panel.fadeIn( 'slow' ).attr( 'aria-hidden', 'false' );
		}
	};

	const setPanel = id => {
		const panelId = `${ id }-panel`;

		$( 'select.tab-select' ).val( id );
		$( '#' + id ).attr( 'aria-selected', 'true' );
		$( '#' + panelId ).attr( 'aria-hidden', 'false' );
		$( '[role="tabpanel"][aria-hidden="true"]' ).fadeOut( 'fast' );
	};

	return {
		init() {
			if ( ! $( '[data-tab="group"]' ).length ) {
				return;
			}

			const queryValues = getQueryValues();

			if ( queryValues && 'tab' in queryValues ) {
				setPanel( queryValues.tab );
			} else {
				setPanel( $( 'select.tab-select option:first' ).val() );
			}

			this.bind();
		},
		bind() {
			$( 'select.tab-select' ).change( e => {
				toggle( {
					button: $( e.currentTarget ).val(),
					panel: $( e.currentTarget ).val() + '-panel'
				} );
			} );
			$( '[role="tab"]' ).on( 'click', e => {
				toggle( {
					button: $( e.currentTarget ).attr( 'id' ),
					panel: $( e.currentTarget ).attr( 'aria-controls' )
				} );
			} );
		}
	};
};

tabToggle( jQuery ).init();

const accordionToggle = function( $ ) {
	let $currentPanel = null;
	let siblings = [];

	const toggle = $panel => {
		$currentPanel = $panel;
		getSiblingAccordions( $panel );

		if ( isCurrentlyAnimating() ) {
			return;
		}

		// closeSiblings();

		if ( $panel.attr( 'data-state' ) === 'closed' ) {
			openPanel( $panel );
		} else {
			closePanel( $panel );
		}
	};

	const openPanel = $panel => {
		const $content = $panel.find( '[data-accordion="content"]' );
		const newHeight = $content.get( 0 ).scrollHeight;

		$panel.attr( 'data-state', 'expanding' );

		$content.animate( {
			height: newHeight
		}, 400, () => {
			$panel.attr( 'data-state', 'expanded' );
			$content.css( { height: 'auto' } );
		} );
	};

	const closePanel = $panel => {
		const $content = $panel.find( '[data-accordion="content"]' );

		$panel.attr( 'data-state', 'closing' );

		$content.animate( {
			height: 0
		}, 400, () => {
			$panel.attr( 'data-state', 'closed' );
		} );
	};

	const isCurrentlyAnimating = () => {
		const state = $currentPanel.attr( 'data-state' );

		if ( state === 'expanding' || state === 'closing' ) {
			return true;
		}

		for ( let i = 0; i < siblings.length; i++ ) {
			const $panel = siblings[ i ];
			const siblingState = $panel.attr( 'data-state' );

			if ( siblingState === 'expanding' || siblingState === 'closing' ) {
				return true;
			}
		}
	};

	const closeSiblings = () => {
		for ( let i = 0; i < siblings.length; i++ ) {
			const $panel = siblings[ i ];

			if ( $panel.attr( 'data-state' ) === 'expanded' ) {
				closePanel( $panel );
			}
		}
	};

	const getSiblingAccordions = $accordion => {
		siblings = [];
		let searchPrev = true;
		let searchNext = true;
		let $currentEl = null;

		while ( searchPrev === true || searchNext === true ) {
			$currentEl = $currentEl === null ? $accordion : $currentEl;

			if ( searchPrev === true && $currentEl.prev( '[data-accordion="panel"]' ).length ) {
				siblings.push( $currentEl.prev( '[data-accordion="panel"]' ) );
				$currentEl = $currentEl.prev( '[data-accordion="panel"]' );
				continue;
			} else if ( searchPrev === true && ! $currentEl.prev( '[data-accordion="panel"]' ).length ) {
				searchPrev = false;
				$currentEl = null;
				continue;
			}

			if ( searchNext === true && $currentEl.next( '[data-accordion="panel"]' ).length ) {
				siblings.push( $currentEl.next( '[data-accordion="panel"]' ) );
				$currentEl = $currentEl.next( '[data-accordion="panel"]' );
				continue;
			} else if ( searchNext === true && ! $currentEl.next( '[data-accordion="panel"]' ).length ) {
				searchNext = false;
			}
		}

		return siblings;
	};

	return {
		init() {
			if ( ! $( '[data-accordion="panel"]' ).length ) {
				return;
			}

			$( '[data-accordion="content"]' ).css( { height: 0 } );

			const queryValues = getQueryValues();

			if ( queryValues && 'accordion' in queryValues ) {
				toggle( $( '#' + queryValues.accordion ).parents( '[data-accordion="panel"]' ) );
			}

			$( '[data-accordion="content"] > .content-main' )
				.append( '<button class="accordion-close" data-accordion="close">Close</button>' );

			this.bind();
		},
		bind() {
			$( '[data-accordion="toggle"]' ).on( 'click', e => {
				toggle( $( e.currentTarget ).parents( '[data-accordion="panel"]' ) );
			} );

			$( '[data-accordion="close"]' ).on( 'click', e => {
				closePanel( $( e.currentTarget ).parents( '[data-accordion="panel"]' ) );
			} );
		}
	};
};

accordionToggle( jQuery ).init();

const siteCarousel = function( $ ) {
	return {
		bind() {
			$( '.carousel-wrapper' ).slick( {
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				nextArrow: '<button class="slick-next slick-arrow" type="button"><span class="sr-only">Next</span><i class="fal fa-chevron-right" aria-hidden="true"></i></button>',
				prevArrow: '<button class="slick-prev slick-arrow" type="button"><span class="sr-only">Previous</span><i class="fal fa-chevron-left" aria-hidden="true"></i></button>',
			} );
		}
	};
};

siteCarousel( jQuery ).bind();

const collapsibleToggle = ( $ ) => {
	const toggle = $panel => {
		const status = $panel.data( 'status' );

		if ( status === 'collapsing' || status === 'expanding' ) {
			return;
		}

		if ( status === 'collapsed' ) {
			expand( $panel );
		} else {
			collapse( $panel );
		}
	};

	const expand = $panel => {
		const $toggle = $panel.find( '[data-collapsible="toggle"]' );
		const $wrapper = $panel.find( '[data-collapsible="wrapper"]' );

		const newHeight = $wrapper.get( 0 ).scrollHeight;

		$panel.attr( 'data-status', 'expanding' );
		$panel.data( 'status', 'expanding' );

		$wrapper.animate( {
			height: newHeight
		}, 400, () => {
			$wrapper.css( { height: 'auto' } );
			$panel.attr( 'data-status', 'expanded' );
			$panel.data( 'status', 'expanded' );
			$toggle.attr( 'aria-expanded', true );
		} );
	};

	const collapse = $panel => {
		const $toggle = $panel.find( '[data-collapsible="toggle"]' );
		const $wrapper = $panel.find( '[data-collapsible="wrapper"]' );

		$panel.attr( 'data-status', 'collapsing' );
		$panel.data( 'status', 'collapsing' );

		$wrapper.animate( {
			height: 0
		}, 400, () => {
			$panel.attr( 'data-status', 'collapsed' );
			$panel.data( 'status', 'collapsed' );
			$toggle.attr( 'aria-expanded', false );
		} );
	};

	return {
		init() {
			$( '[data-collapsible="wrapper"]' ).css( {
				overflow: 'hidden'
			} );

			$( '[data-collapsible="panel"][data-status="collapsed"] [data-collapsible="wrapper"]' ).css( {
				height: 0
			} );

			this.bind();
		},
		bind() {
			$( '[data-collapsible="toggle"]' ).on( 'click', e => {
				toggle( $( e.currentTarget ).parents( '[data-collapsible="panel"]' ) );
			} );
		}
	};
};

collapsibleToggle( jQuery ).init();

const addShareLinks = $ => {
	const getCopyLinkMarkup = ( id, qstring ) => {
		const linkId = `${ id }-link`;

		return `
			<div class="copy-link">
				<input type="text" id="${ linkId }" value="${ qstring }" aria-hidden="true">
				<button class="copy-link-btn" data-copy-link="${ linkId }">
					<span class="sr-only">Copy Share Link</span><i class="fas fa-link" aria-hidden="true"></i>
				</button>
			</div>
		`;
	};

	const addTabAnchor = $panel => {
		const id = $panel.attr( 'id' ).replace( '-panel', '' ).trim();
		const qstring = `${ window.location.origin }${ window.location.pathname }?tab=${ id }`;
		$panel.prepend( getCopyLinkMarkup( id, qstring ) );
	};

	const addAccordionAnchor = $panel => {
		const id = $panel.find( '[data-accordion="toggle"]' ).attr( 'id' );
		let qstring = `${ window.location.origin }${ window.location.pathname }?`;

		if ( $panel.parents( '[role="tabpanel"]' ).length ) {
			const tabId = $panel.parents( '[role="tabpanel"]' ).attr( 'id' ).replace( '-panel', '' ).trim();
			qstring += `tab=${ tabId }&`;
		}

		qstring += `accordion=${ id }`;

		$panel.find( '[data-accordion="content"] .content-main' ).prepend( getCopyLinkMarkup( id, qstring ) );
	};

	return {
		bind() {
			if ( ! $( '[role="tabpanel"]' ).length && ! $( '[data-accordion="panel"]' ).length ) {
				return;
			}

			$( '[role="tabpanel"]' ).each( ( i, el ) => {
				addTabAnchor( $( el ) );
			} );

			$( '[data-accordion="panel"]' ).each( ( i, el ) => {
				addAccordionAnchor( $( el ) );
			} );

			$( '[data-copy-link]' ).popover( {
				trigger: 'hover',
				content: 'Copy Link',
				placement: 'bottom',
				animation: true
			} );

			$( document ).on( 'click', '[data-copy-link]', e => {
				const $btn = $( e.currentTarget );
				const linkId = $btn.attr( 'data-copy-link' );
				const link = document.getElementById( linkId );

				link.select();
				link.setSelectionRange( 0, 99999 );
				document.execCommand( 'copy' );

				$( '.popover.show .popover-body' ).text( 'Link Copied' );

				setTimeout( () => {
					$btn.popover( 'hide' );
				}, 500 );
			} );
		}
	};
};

addShareLinks( jQuery ).bind();

const externalLinks = ( $ ) => {
	const host = window.location.hostname;

	$( '.wp-block-button__link' ).each( ( i, el ) => {
		const $el = $( el );
		const linkTarget = $el.attr( 'target' );
		const linkUrl = $el.attr( 'href' );

		if ( ! linkTarget && ! linkUrl.includes( host ) ) {
			$el.attr( 'target', '_blank' ).attr( 'rel', 'noopener noreferrer' );
		}
	} );
};

externalLinks( jQuery );
